module.exports = __webpack_public_path__ + "img/micropayment-alternative.499a7053.png";